import React, { Component } from 'react';
import ItemsEdit from '../Shared/Items/ItemsBooleanDefault';

import {
    stepExclusionSchema,
} from '@swa_llow/pricing_engine';

class ExclusionsEdit extends Component {
    render() {
        const { 
            step,
            inputs,
            is_approved,
        } = this.props;

        return <ItemsEdit
            schema={stepExclusionSchema}
            set_error={this.props.set_error}
            updateStep={this.props.updateStep}
            step={step}
            inputs={inputs}
            header={'Exclusions list'}
            description={'This section allows you to create a list of exclusions reasons (i.e. why you will not provide a price or premium to a quote).'}
            tag={'Exclusion'}
            is_approved={is_approved}
        />;
    }
}

export default ExclusionsEdit;